import {
  capabilityDefinitionSnapshot,
  type CapabilityDefinitionSnapshotV1,
} from '../definition/consumer/contract';

export const CATALOG_SCOPE = 'LOCAL_SYNTHETIC_OWNER_CURRENT_PUBLISHED';
export const CATALOG_LIMIT = 100;
export interface CapabilityDefinitionCatalogQueryV1 {
  readonly scope: typeof CATALOG_SCOPE;
  readonly limit: typeof CATALOG_LIMIT;
}
export type CapabilityDefinitionCatalogReadResultV1 = CapabilityDefinitionCatalogQueryV1 &
  (
    | {
        readonly status: 'SUCCESS';
        readonly coverage: 'NOT_TRUNCATED' | 'TRUNCATED_AT_LIMIT';
        readonly items: readonly CapabilityDefinitionSnapshotV1[];
      }
    | { readonly status: 'SOURCE_UNAVAILABLE'; readonly coverage: 'UNKNOWN'; readonly items: null }
  );
export function catalogQuery(): CapabilityDefinitionCatalogQueryV1 {
  return Object.freeze({ scope: CATALOG_SCOPE, limit: CATALOG_LIMIT });
}
export function catalogSuccess(
  items: readonly CapabilityDefinitionSnapshotV1[],
  coverage: 'NOT_TRUNCATED' | 'TRUNCATED_AT_LIMIT',
): CapabilityDefinitionCatalogReadResultV1 {
  if (
    items.length > CATALOG_LIMIT ||
    (coverage === 'TRUNCATED_AT_LIMIT' && items.length !== CATALOG_LIMIT)
  )
    throw new Error('Invalid catalog coverage');
  const copied = items.map((item, index) => {
    capabilityDefinitionSnapshot(item);
    if (
      item.definitionStatus !== 'PUBLISHED' ||
      !Number.isSafeInteger(item.definitionVersion) ||
      !Number.isSafeInteger(item.aggregateVersion)
    )
      throw new Error('Invalid catalog snapshot');
    const previous = items[index - 1];
    if (previous && previous.capabilityId >= item.capabilityId)
      throw new Error('Catalog IDs must be unique and ordered');
    return Object.freeze({ ...item });
  });
  return Object.freeze({
    ...catalogQuery(),
    status: 'SUCCESS',
    coverage,
    items: Object.freeze(copied),
  });
}
export function catalogUnavailable(): CapabilityDefinitionCatalogReadResultV1 {
  return Object.freeze({
    ...catalogQuery(),
    status: 'SOURCE_UNAVAILABLE',
    coverage: 'UNKNOWN',
    items: null,
  });
}
